import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withNavigationErrorHandler,
  withViewTransitions,
} from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LangService } from './common/services/lang.service';
import { TokenStorageService } from './common/services/token-storage.service';
import { ThemeStore } from './common/services/theme.service';
import { tokenInterceptor } from './common/interceptors/token.interceptor';
import { langInterceptor } from './common/interceptors/lang.interceptor';
import { errorInterceptor } from './common/interceptors/global-error.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { reloadOnChunkError } from './common/utils/chunk-reload';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    provideZonelessChangeDetection(),

    provideRouter(
      routes,
      withViewTransitions(),
      withComponentInputBinding(),
      withNavigationErrorHandler(reloadOnChunkError),
    ),

    provideHttpClient(
      withInterceptors([tokenInterceptor, langInterceptor, errorInterceptor]),
    ),

    provideAppInitializer(() => {
      inject(ThemeStore).initTheme();
      inject(LangService).init();
      inject(TokenStorageService).init();
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
